import type {TechnicalDataValue} from '@volkswagen-onehub/car-technical-details-bff';
import type {TranslateFunction} from '../utils/translate';
import type {RowDescription} from './multi-table/getDescriptions';
import {getRowDebugText} from './multi-table/getRowDebugText';

export interface TechnicalDataMultiValue {
  description: RowDescription;
  values: string[];
}

export function mergeTechnicalDataWithSameKey(
  data: TechnicalDataValue[],
  translate: TranslateFunction,
): TechnicalDataMultiValue[] {
  const map = data.reduce(
    (acc, curr) => {
      const description = curr.i18nKey
        ? translate(curr.i18nKey)
        : curr.description || '';
      const existing = acc[curr.key];
      if (existing && existing.values) {
        existing.values.push(curr.value);
      } else {
        acc[curr.key] = {
          description: {
            debugText: getRowDebugText(curr.key),
            label: description,
            disclaimerKey: curr.disclaimerKey,
          },
          values: [curr.value],
        };
      }
      return acc;
    },
    {} as {[key: string]: TechnicalDataMultiValue},
  );

  return Object.values(map);
}
